import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import Loading from "../components/Loading";
import EpisodeCard from "./page/component/EpisodeCard";
import CreateSeries from "./page/CreateEpisode";
import { AddFolderButton, SmallScreenModel } from "components";
import { VideoSeriesProps } from "../series/store/actionType";
import { VideoGroupProps } from "../group/store/actionType";
import { VideoSeasonProps } from "../season/store/actionType";
import { VideoCategoryProps } from "../category/store/actionType";
import { VideoEpisodeProps } from "./store/actionType";
import BreadcrumbFolderLayout from "../components/BreadcrumbFolderLayout";
import { fetchVideoEpisodes } from "./store/action";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { resetVideo } from "../video_detail/store/action";
import { SuperAdminStatusEnum } from '../../../props/enum';

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type Props = DispatchProps & StateProps;

const Episodes: React.FC<Props> = ({
  videoEpisodesState,
  onFetchVideoEpisodes,
  onVideoReset
}) => {
  const navigate = useNavigate();
  //group
  const { groupId } = useParams<{ groupId: string }>();
  const groupsState = useSelector(
    (state: any) => state.videoGroups.videoGroupsState
  );
  const currentGroup = groupsState.groups?.filter(
    (group: VideoGroupProps) => group.id === groupId
  )[0];
  //category
  const { categoryId } = useParams<{ categoryId: string }>();
  const categoryState = useSelector(
    (state: any) => state.videoCategories.videoCategoriesState
  );
  const currentCategory = categoryState.categories?.filter(
    (category: VideoCategoryProps) => category.id === categoryId
  )[0];
  //series
  const { seriesId } = useParams<{ seriesId: string }>();
  const seriesState = useSelector(
    (state: any) => state.videoSeries.videoSeriesState
  );
  const currentSeries = seriesState.video_series?.filter(
    (series: VideoSeriesProps) => series.id === seriesId
  )[0];
  //season
  const { seasonId } = useParams<{ seasonId: string }>();
  const seasonState = useSelector(
    (state: any) => state.videoSeasons.videoSeasonsState
  );
  const currentSeason = seasonState.video_seasons?.filter(
    (season: VideoSeasonProps) => season.id === seasonId
  )[0];

  const [isModalOpen, setModalOpen] = useState(false);
  const closeModal = () => {
    setModalOpen(false);
  };

  const handleSectionClick = (id: string) => {
    navigate(`/video/${groupId}/${categoryId}/${seriesId}/${seasonId}/${id}`);
  };
  const redirectToGroup = () => {
    navigate(`/video`);
  };
  const redirectToCategory = () => {
    navigate(`/video/${groupId}`);
  };
  const redirectToSeries = () => {
    navigate(`/video/${groupId}/${categoryId}`);
  };
  const redirectToSeason = () => {
    navigate(`/video/${groupId}/${categoryId}/${seriesId}`);
  };

  useEffect(() => {
    onFetchVideoEpisodes(seasonId ?? "");
    onVideoReset()
  }, []);
  const breadcrumbItem = [
    {
      group: "Group",
      root: "Root",
      active: true,
      onClick: () => redirectToGroup(),
    },
    {
      group: currentGroup?.name,
      root: "Group",
      active: true,
      onClick: () => redirectToCategory(),
    },
    {
      group: currentCategory?.name,
      root: "Category",
      active: true,
      onClick: () => redirectToSeries(),
    },
    {
      group: currentSeries?.title,
      root: "Series",
      active: true,
      onClick: () => redirectToSeason(),
    },
    {
      group: currentSeason?.title,
      root: "Season",
    },
  ];
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.CREATE_EPISODE));
  return (
    <div className="h-full overflow-hidden">
      {videoEpisodesState && videoEpisodesState.isLoading && <Loading />}
      <BreadcrumbFolderLayout
        groupData={videoEpisodesState?.video_episode}
        breadcrumbItem={breadcrumbItem}
        addFolderButton={
          <>
            {isPermitted && (
              <AddFolderButton onClick={() => setModalOpen(true)}>
                Create Episode
              </AddFolderButton>
            )}
          </>
        }
        folders={
          <>
            <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 gap-6">
              {videoEpisodesState &&
                videoEpisodesState?.video_episode &&
                videoEpisodesState?.video_episode.map(
                  (episodeData: VideoEpisodeProps) => (
                    <EpisodeCard
                      key={episodeData.id}
                      episodeId={episodeData.id}
                      episodeData={episodeData}
                      onClick={() => handleSectionClick(episodeData.id)}
                    />
                  )
                )}
            </div>
          </>
        }
      />
      <SmallScreenModel showModal={isModalOpen} setShowModal={setModalOpen}>
        <CreateSeries
          isModalOpen={isModalOpen}
          closeModal={closeModal}
          seasonData={currentSeason}
        />
      </SmallScreenModel>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  videoEpisodesState: state.videoEpisodes?.videoEpisodeState,
});

const mapDispatchToProps = (dispatch: any) => ({
  onFetchVideoEpisodes: (season_id: string) =>
    dispatch(fetchVideoEpisodes(season_id)),
  onVideoReset: () =>
    dispatch(resetVideo()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Episodes);
